import { Case, UserAccount } from "../data/types";
import { useEffect, useRef, useCallback } from "react";
import SignalRServiceManager from "./SignalRServiceManager";

type CaseSignalRProps = {
    primaryAccount?: UserAccount;
    onUpsertCase?: (caseObj: Case[]) => void;
}
export const useCaseSignalR = (props: CaseSignalRProps) => {
    const { primaryAccount, onUpsertCase } = props;
    const messageName = "upsertCase";

    // Use useRef to maintain stable reference
    const onUpsertCaseRef = useRef(onUpsertCase);

    useEffect(() => {
        onUpsertCaseRef.current = onUpsertCase;
    }, [onUpsertCase]);

    const upsertHandler = useCallback((caseJson: string) => {
        try {
            const cases = JSON.parse(caseJson);
            onUpsertCaseRef.current?.(cases);
        } catch (error) {
            console.error("Failed to parse signalR message:", error, caseJson);
        }
    }, []); // Now stable

    useEffect(() => {
        let signalRManager: Awaited<ReturnType<typeof SignalRServiceManager.getInstance>> | null = null;

        const setupSignalR = async () => {
            if (primaryAccount) {
                signalRManager = await SignalRServiceManager.getInstance(primaryAccount);
                signalRManager?.on(messageName, upsertHandler); // No need to off/on
            }
        };

        setupSignalR();

        return () => {
            signalRManager?.off(messageName, upsertHandler);
        };
    }, [primaryAccount, upsertHandler]); // Include dependencies

    return null;
}